<template>
    <div @keydown.esc="closeAllDropdown" v-click-outside="closeAllDropdown" tabindex="0" class="customer-holder">
        <div class="padded-top with-green-bg">
            <div class="container">
                <table id="customer-list" cellpadding="0" cellspacing="0" class="cap">
                    <thead v-if="sessionsLoaded" class="with-border-bottom first">
                        <tr>
                            <th>&nbsp;</th>
                            <th colspan="2">Activity Status</th>
                            <th>BJF</th>
                            <th>BJS</th>
                            <th>SJF</th>
                            <th>SJS</th>
                            <th>SW</th>
                            <th>&nbsp;</th>
                            <th>TC</th>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody class="activity-status" v-if="sessionsLoaded">
                        <tr>
                            <td>
                                <div class="status-wrap d-flex align-items-center">
                                    <span class="status not-assigned"></span>
                                </div>
                            </td>
                            <td colspan="2">Not assigned to a group: </td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>{{ swTotal.notAssigned }}</td>
                            <td>&nbsp;</td>
                            <td>{{ tcTotal.notAssigned }}</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="status-wrap d-flex align-items-center">
                                    <span class="status waiting"></span>
                                </div>
                            </td>
                            <td colspan="2">Waiting for Media: </td>
                            <td>{{ bjfTotal.waiting }}</td>
                            <td>{{ bjsTotal.waiting }}</td>
                            <td>{{ sjfTotal.waiting }}</td>
                            <td>{{ sjsTotal.waiting }}</td>
                            <td>{{ swTotal.waiting }}</td>
                            <td>&nbsp;</td>
                            <td>{{ tcTotal.waiting }}</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="status-wrap d-flex align-items-center">
                                    <span class="status processing"></span>
                                </div>
                            </td>
                            <td colspan="2">Processing / Uploading: </td>
                            <td>{{ bjfTotal.processing }}</td>
                            <td>{{ bjsTotal.processing }}</td>
                            <td>{{ sjfTotal.processing }}</td>
                            <td>{{ sjsTotal.processing }}</td>
                            <td>{{ swTotal.processing }}</td>
                            <td>&nbsp;</td>
                            <td>{{ tcTotal.processing }}</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="status-wrap d-flex align-items-center">
                                    <span class="status uploaded"></span>
                                </div>
                            </td>
                            <td colspan="2">Uploaded / Customer Notified: </td>
                            <td>{{ bjfTotal.uploaded }}</td>
                            <td>{{ bjsTotal.uploaded }}</td>
                            <td>{{ sjfTotal.uploaded }}</td>
                            <td>{{ sjsTotal.uploaded }}</td>
                            <td>{{ swTotal.uploaded }}</td>
                            <td>&nbsp;</td>
                            <td>{{ tcTotal.uploaded }}</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                    </tbody>
                    <thead v-if="sessionsLoaded" class="with-border-top foot">
                        <tr style="vertical-align: top;">
                            <th>&nbsp;</th>
                            <th colspan="2">Total Subscribed: </th>
                            <th>{{ totalBJF }}</th>
                            <th>{{ totalBJS }}</th>
                            <th>{{ totalSJF }}</th>
                            <th>{{ totalSJS }}</th>
                            <th>{{ totalSW }}<br><span class="foc">({{ focTotal }})</span></th>
                            <th>&nbsp;</th>
                            <th>{{ totalTC }}</th>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    
                    <thead class="padding-top white-bg">
                        <tr>
                            <th>&nbsp;</th>
                            <th>Session no. <span class="filter-down"></span></th>
                            <th style="width: 500px;">&nbsp;</th>
                            <th>BJF</th>
                            <th>BJS</th>
                            <th>SJF</th>
                            <th>SJS</th>
                            <th>SW</th>
                            <th>&nbsp;</th>
                            <th>TC</th>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody v-if="!sessionsLoaded" class="white-bg">
                        <tr>
                            <td colspan="12">Loading Customers...</td>
                        </tr>
                    </tbody>
                    <customer :index="index" :session="session" v-for="(session, index) in sessions" :key="index" :show_nfc_column="show_nfc"></customer>     
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import customer from './CustomerComponent';
    import mediaStatusHeader from './MediaStatusHeader';
    import {mapActions, mapState, mapGetters} from 'vuex';

    export default {
        props: ['show_nfc'],
        components: {
            customer,
            mediaStatusHeader
        },
        computed: {
            ...mapState([
               'sessions', 
               'sessionsLoaded', 
               'mediaStatusIsLoaded', 
               'mediaStatusHasDisabled'
            ]),
            ...mapGetters([
                'bjfTotal', 
                'bjsTotal',
                'sjfTotal', 
                'sjsTotal',
                'swTotal',
                'tcTotal',
                'focTotal'
            ]),
            totalBJF() {
                return this.bjfTotal.waiting + this.bjfTotal.processing + this.bjfTotal.uploaded;
            },
            totalBJS() {
                return this.bjsTotal.waiting + this.bjsTotal.processing + this.bjsTotal.uploaded;
            },
            totalSJF() {
                return this.sjfTotal.waiting + this.sjfTotal.processing + this.sjfTotal.uploaded;
            },
            totalSJS() {
                return this.sjsTotal.waiting + this.sjsTotal.processing + this.sjsTotal.uploaded;
            },
            totalSW() {
                return this.swTotal.waiting + this.swTotal.processing + this.swTotal.uploaded + this.swTotal.notAssigned;
            },
            totalTC() {
                return this.tcTotal.waiting + this.tcTotal.processing + this.tcTotal.uploaded + this.tcTotal.notAssigned;
            },
        },
        methods: {
            ...mapActions(['fetchSessions', 'fetchGroups', 'fetchMediaStatus']),
            closeAllDropdown() {
                this.$store.state.dropDownActive = null;
            },
        },
        async created() {
            await this.fetchSessions();
            this.fetchGroups();
            this.fetchMediaStatus();
            this.$store.commit('clearCount');
        }
    }
</script>
<style>
    .customer-holder {
        outline: none;
    }
</style>

